import type { UserRole } from '@services/auth';
import type { QuestionnaireData, AIGeneratedQuestion } from '@data/publicPlans';

/** Session payload until the user signs in; cleared after successful auth + handoff to generate-plan. */
export const GUEST_PENDING_QUESTIONNAIRE_SESSION_KEY = 'gardenhub:guestPendingQuestionnaire';

export type GuestPendingQuestionnairePayload = {
	questionnaire: QuestionnaireData & { aiAllQuestions?: AIGeneratedQuestion[] };
	contactEmail: string;
	inviteCode?: string;
};

/**
 * If a guest had started “create plan”, moves answers into `pendingQuestionnaire` and returns the
 * post-login navigation target. Plan/photo AI still runs only on `/app/seeker/generate-plan` after auth.
 */
export function consumeGuestPendingForGeneration(
	userRole: UserRole | undefined
): { path: string; state?: { inviteCode?: string } } | 'wrong_role' | null {
	const raw = sessionStorage.getItem(GUEST_PENDING_QUESTIONNAIRE_SESSION_KEY);
	if (!raw) {
		return null;
	}
	if (!userRole || (userRole !== 'seeker' && userRole !== 'admin')) {
		sessionStorage.removeItem(GUEST_PENDING_QUESTIONNAIRE_SESSION_KEY);
		return 'wrong_role';
	}
	try {
		const payload = JSON.parse(raw) as GuestPendingQuestionnairePayload;
		sessionStorage.removeItem(GUEST_PENDING_QUESTIONNAIRE_SESSION_KEY);
		localStorage.setItem(
			'pendingQuestionnaire',
			JSON.stringify({
				questionnaire: payload.questionnaire,
				contactEmail: payload.contactEmail
			})
		);
		return {
			path: '/app/seeker/generate-plan',
			state: payload.inviteCode?.trim() ? { inviteCode: payload.inviteCode.trim() } : undefined
		};
	} catch {
		sessionStorage.removeItem(GUEST_PENDING_QUESTIONNAIRE_SESSION_KEY);
		return null;
	}
}
